import { createContext, useContext } from 'react';

type IFontsContext = {
  loadingCustomFonts: () => void;
  areMainFontsLoaded: boolean;
};

const FontsContext = createContext<IFontsContext>({
  loadingCustomFonts: () => void 0,
  areMainFontsLoaded: false,
});

const useFontsContext = () => {
  return useContext(FontsContext);
};

export { useFontsContext, FontsContext };
